export default __webpack_public_path__ + "static/media/loadingHome.536fe8c7.gif";